import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as d3 from 'd3';
import drawTextMixin from './d3textMixin.js'; // magic numbers based on original SVG file size

var INNER_WIDTH = 104;
var INNER_START = 18;
export default {
  name: 'CoreChartBattery',
  mixins: [drawTextMixin],
  props: {
    size: {
      type: Number,
      default: 200
    },
    value: {
      type: Number,
      default: 0
    },
    solid: {
      type: Boolean,
      default: false
    },
    monochrome: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      segments: 5,
      colorRange: ['#ff1744', '#fb8c00', '#fec60a', '#7cb342', '#388e3c']
    };
  },
  computed: {
    valueSanitized: function valueSanitized() {
      return Math.max(Math.min(this.value, 100), 0);
    },
    color: function color() {
      return this.$store.state.app.UiTheme ? '#bdbdbd' : '#757575';
    },
    textColor: function textColor() {
      return this.$store.state.app.UiTheme ? '#ccc' : '#333';
    }
  },
  watch: {
    size: function size() {
      this.draw();
    },
    value: function value() {
      this.draw();
    },
    solid: function solid() {
      this.draw();
    },
    monochrome: function monochrome() {
      this.draw();
    },
    color: function color() {
      this.draw();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.draw();
    });
  },
  methods: {
    drawSegments: function drawSegments() {
      var segments = this.segments;
      var segmentMargin = 4;
      var segCount = Math.round(this.valueSanitized / 100 * segments);
      var marginSum = segmentMargin * (segments - 1);
      var segWidth = (INNER_WIDTH - marginSum) / segments;
      var colors = this.monochrome ? [this.color] : this.colorRange;
      var color = d3.scaleThreshold().domain([25, 50, 75, 100]).range(colors);
      var svg = d3.select(this.$el);

      for (var step = 0; step < segCount; step++) {
        var fromX = INNER_START + step * segmentMargin + step * segWidth;
        var toX = fromX + segWidth;
        var batteryInner = "M".concat(fromX, ",18 L").concat(toX, ",18 L").concat(toX, ",62 L").concat(fromX, ",62 L").concat(fromX, ",18 Z");
        svg.append('path').style('stroke', color(segCount / segments * 100)).style('stroke-width', 0).style('fill', color(segCount / segments * 100)).attr('d', batteryInner);
      }
    },
    drawSolid: function drawSolid() {
      var svg = d3.select(this.$el);
      var colors = this.monochrome ? [this.color] : this.colorRange;
      var color = d3.scaleThreshold().domain([25, 50, 75, 100]).range(colors);
      var width = d3.scaleLinear().domain([0, 100]).range([INNER_START, INNER_WIDTH + INNER_START]);
      var batteryInner = "M18,18 L".concat(width(this.valueSanitized), ",18 L").concat(width(this.valueSanitized), ",62 L18,62 L18,18 Z");
      svg.append('path').style('stroke', color(this.valueSanitized)).style('stroke-width', 0).style('fill', color(this.valueSanitized)).attr('d', batteryInner);
    },
    draw: function draw() {
      // clear existing svg content
      d3.select(this.$el).selectAll('*').remove(); // render "N/A" if value is not a number

      if (isNaN(parseFloat(this.value))) {
        return this.drawNotAvailable();
      }

      var svg = d3.select(this.$el).attr('width', this.size).attr('height', this.size).attr('viewBox', '0 0 152 82').append('g').attr('transform', 'translate(1,1)'); // draw outer battery body

      var batteryBody = "\n        M10,10 L10,70 L130,70 L130,10 L10,10 Z M131,0 C136.178993,0 140,3.89443632 140,9 L140,22 L150,22 L150,58 L140,58 L140,71 C140,76.0438985 136.159096,80 131,80 L9,80 C3.82100687,80 0,76.1055637 0,71 L0,9.24444115 C0,4.20054262 3.84090453,0 9,0 L131,0 Z\n      ";
      svg.append('path').style('fill', this.color).attr('d', batteryBody);

      if (this.solid) {
        // draw solid fill
        this.drawSolid(svg);
      } else {
        // draw segmented fill
        this.drawSegments(svg);
      }
    }
  }
};